import { ActivityAction, EntityType } from "../types";
import { TWTheme } from "@tw/tw-component-library";

export const COLORS = {
  BACKGROUND_PRIMARY: `${({ theme }: { theme: TWTheme }) => theme.colors.backgroundPrimary}`,
  BACKGROUND: `${({ theme }: { theme: TWTheme }) => theme.colors.background}`,
  BORDER_LIGHT: `${({ theme }: { theme: TWTheme }) => theme.colors.border.light}`,
  TEXT_PRIMARY: `${({ theme }: { theme: TWTheme }) => theme.colors.text.primary}`,
  TEXT_SECONDARY: `${({ theme }: { theme: TWTheme }) => theme.colors.text.secondary}`,
  PRIMARY: `${({ theme }: { theme: TWTheme }) => theme.colors.primary}`,
  SECONDARY: `${({ theme }: { theme: TWTheme }) => theme.colors.secondary}`,
  SUCCESS: `${({ theme }: { theme: TWTheme }) => theme.colors.success}`,
  WARNING: `${({ theme }: { theme: TWTheme }) => theme.colors.warning}`,
  ERROR: `${({ theme }: { theme: TWTheme }) => theme.colors.error}`,
  SECONDARY_PALETTE: {
    GRAY: `${({ theme }: { theme: TWTheme }) => theme.colors.secondaryPalette?.gray}`,
    YELLOW: `${({ theme }: { theme: TWTheme }) => theme.colors.secondaryPalette?.yellow}`,
    BROWN: `${({ theme }: { theme: TWTheme }) => theme.colors.secondaryPalette?.brown}`,
    GREEN: `${({ theme }: { theme: TWTheme }) => theme.colors.secondaryPalette?.green}`,
    DARK_GREEN: `${({ theme }: { theme: TWTheme }) => theme.colors.secondaryPalette?.darkGreen}`,
    BLUE: `${({ theme }: { theme: TWTheme }) => theme.colors.secondaryPalette?.blue}`,
    NAVY: `${({ theme }: { theme: TWTheme }) => theme.colors.secondaryPalette?.navy}`,
    RED: `${({ theme }: { theme: TWTheme }) => theme.colors.secondaryPalette?.red}`,
  },
  PRIMARY_PALETTE: {
    PURPLE: `${({ theme }: { theme: TWTheme }) => theme.colors.primaryPalette?.purple}`,
    PAPER_WHITE: `${({ theme }: { theme: TWTheme }) => theme.colors.primaryPalette?.paperWhite}`,
    INK_BLACK: `${({ theme }: { theme: TWTheme }) => theme.colors.primaryPalette?.inkBlack}`,
    PAPER_WHITE_TINT: `${({ theme }: { theme: TWTheme }) => theme.colors.primaryPalette?.paperWhiteTint}`,
    INK_BLACK_TINT: `${({ theme }: { theme: TWTheme }) => theme.colors.primaryPalette?.inkBlackTint}`,
  },
} as const;

export const ACTIVITY_ACTIONS: (ActivityAction | 'all')[] = [
  'all',
  'Created',
  'Deleted',
  'Modified',
  'Removed',
  'Added',
  'Opened',
];

export const ENTITY_TYPES: (EntityType | 'all')[] = [
  'all',
  'ChatSession',
  'ChatPersona',
  'ChatMessage',
  'ChatPrompt',
  'Workflow',
  'DataRoomFile',
  'DataRoomCollection',
  'CollectionDataRoomFile',
  'Workspace',
  'WorkspaceUser',
];

export const ITEMS_PER_PAGE = 5;
